/**
 * @description renders a link in the navigation section of the application bar
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Link from '@mui/material/Link';

const styles = {
  navigationLink: {
    color: 'primary.contrastText',
    fontWeight: 'bold',
    padding: 0,
    textAlign: 'left',
    wordBreak: 'break-word',

    '&:hover': {
      textDecoration: 'none'
    }
  },
  navigationLinkDropdown: {
    display: 'block',
    fontWeight: 'bold',
    paddingX: 2,
    paddingY: 0.75,
    textDecoration: 'none',
    width: '100%',

    '&:hover': {
      textDecoration: 'none'
    }
  }
};

/**
 * @prop {string} label - the label of the navigation link
 * @prop {string} path - the path of the link
 * @prop {boolean} reloadDocument - indicates if the link should hit the server instead of react-router
 * @prop {string} variant - indicates if the link is being used inside a "dropdown" or not (affects the styling of the link)
 */
const NavLink = ({
  label,
  path,
  reloadDocument,
  variant
}) => (
  <Link
    href={path}
    sx={variant === 'dropdown' ? styles.navigationLinkDropdown : styles.navigationLink}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(reloadDocument ? { reloadDocument: true } : {})}
  >
    {label}
  </Link>
);

NavLink.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  reloadDocument: PropTypes.bool,
  variant: PropTypes.string
};

NavLink.defaultProps = {
  reloadDocument: true,
  variant: 'none'
};

export default NavLink;
